export default "__VITE_ASSET__CpNkeNWH__"